import React from 'react';
import { Route, Routes } from 'react-router-dom';
import Main from './Home/MainPage/Main';
import BudgetBuddy from './BudgetBuddy/BudgetBuddy';
import StockMarketGame from './StockMarketGame/StockMarketGame';
import ForgotPassword from './ForgotPassword/ForgotPassword';
import Forum from './Forum/Forum';
import ContactUs from './ContactUs/ContactUs';
import LogIn from './LogIn/LogIn';
import AboutUs from './AboutUs/AboutUs';
import PrivateRoute from './Forum/PrivateRoute';
import Financle from './Financle/Financle';
function AppRouter() {
  return (
    <>
      <Routes>
        <Route exact path="/" element={<Main />} />
        <Route exact path="/budgetbuddy" element={<BudgetBuddy />} />
        <Route exact path="/stockmarketgame" element={<StockMarketGame />} />
        <Route exact path="/forum" element={<Forum />} />
        <Route exact path="/contactus" element={<ContactUs />} />
        <Route exact path="/login" element={<LogIn />} />
        <Route exact path="/aboutus" element={<AboutUs />} />
        <Route exact path="/forgotpassword" element={<ForgotPassword />} />
        <Route exact path="/financle" element={<Financle />} />
      </Routes>
      </>
  );
}

export default AppRouter;
